'use strict';

var getJqueryElement = function(elem) {
    return (elem instanceof $) ? elem : $(elem);
};

var getValidationField = function($el) {
    return $el.parents().closest('.validation_field');
};

var getWrongLabel = function($el) {
    return getValidationField($el).find('.wrong_label');
};

var setFieldState = function(elem, isBlurValidation, allowsEmpty) {
    var $el = getJqueryElement(elem);
    var value = $el.val();
    var validationField = getValidationField($el);
    var currentState = validationField.attr('data-state');
    var state = 'valid';
    if (!allowsEmpty && Odigeo._.isEmpty(value)) {
        state = currentState === 'init' && isBlurValidation ? 'init' : 'empty';
    } else if (!new RegExp($el.data('pattern')).test(value)) {
        state = 'invalid';
    }
    validationField.attr('data-state', state);
    return state;
};

var showFieldError = function(elem, isPaxPage) {
    var $el = getJqueryElement(elem);
    var $input = Odigeo._.size($el.find('input')) > 0 ? $el.find('input') : $el.find('select').first();
    var $error = $el.find('.wrong_label');
    var isEmpty = isPaxPage ?
        Odigeo._.isEmpty($input.val()) && !Odigeo._.isEmpty($input.data('mandatory')) && Odigeo._.isEmpty($input.data('requiredoptional')) :
        $el.attr('data-state') === 'empty';

    $error.text($input.data(isEmpty ? 'mandatory' : 'error'));
};

var checkRegex = function(value, pattern) {
    return new RegExp(pattern).test(value);
};

var toggleFocus = function($el, isFocus) {
    var validationField = getValidationField($el);
    validationField.toggleClass('focused', isFocus);
    if (isFocus) {
        validationField.attr('data-state', 'focused');
    }
};

var validationTypes = {
    REGEX_VALIDATOR: checkRegex,
    SECOND_EMAIL_VALIDATOR: checkRegex,
    NULL_VALIDATOR: function(value) {
        return !!value;
    },
    OPTIONAL: function() {
        return true;
    },
};

module.exports = {
    setState: setFieldState,
    setStateAndShowError: function(elem, isBlurValidation, allowsEmpty) {
        var $el = getJqueryElement(elem);
        var state = setFieldState($el, isBlurValidation, allowsEmpty);
        if (Odigeo._.indexOf(['empty', 'invalid'], state) > -1) {
            showFieldError($el.parents().closest('.validation_field'));
        }
    },
    showError: showFieldError,
    showHidePlaceholder: function(elem, isVisible) {
        var $el = getJqueryElement(elem);
        var $bottomPlaceholder = $el.siblings('.bottom_placeholder').length === 0 ?
            $el.parent().siblings('.bottom_placeholder') : $el.siblings('.bottom_placeholder');

        if ($bottomPlaceholder.length > 0) {
            $bottomPlaceholder.toggleClass('showed', isVisible);
        }
    },
    validateField: function($input) {
        var validation = $input.data('validationType');
        var value = $input.val();
        var regex = $input.data('pattern');
        return validationTypes[validation] ? validationTypes[validation](value, regex) : !!value;
    },
    setDataStateAndShowLabel: function(field, state, labelText) {
        var $field = getJqueryElement(field);
        var $errorLabel = getWrongLabel($field);
        var $validationField = getValidationField($field);

        $validationField.attr('data-state', state);
        $errorLabel.text(labelText);
    },
    scrollToFirstError: function($page, options = {}) {
        Odigeo.Utils.scrollToElement($page.find('.validation_field')
            .filter('.empty, .invalid, [data-state="empty"], [data-state="invalid"]').eq(0), options);
    },
    setFocus: function(elem) {
        toggleFocus(getJqueryElement(elem), true);
    },
    removeFocus: function(elem) {
        toggleFocus(getJqueryElement(elem), false);
    },
    clearField: function(evt) {
        var $el = $(evt.target).closest('.validation_field').find('input');
        $el.val('');
        $el.focus();
        return $el;
    },
    trimCreditCardNumber: function(ccNumber) {
        return ccNumber.replace(/[/\s-]/g, '');
    },
    removeRegexStartAndEndCharacters: function(regexStr) {
        return new RegExp(Odigeo._.trim(regexStr, '$^'), 'g');
    },
    giveWrongCharacters: function($field) {
        var field;
        var stringMatches;
        if ($field.data('validationType') === 'REGEX_VALIDATOR' || $field.data('validationType') === 'CPF_VALIDATOR') {
            field = $field.val();
            stringMatches = field.match(this.removeRegexStartAndEndCharacters($field.data('pattern')));
            if (Odigeo._.startsWith($field.data('name'), 'phoneNumber')) {
                var regexNoNumbers = field.match(/[^0-9]/gi);
                field = stringMatches && regexNoNumbers ? regexNoNumbers.join('') : 'length_' + field.length;
            } else {
                Odigeo._.each(stringMatches, function(toReplace) {
                    field = field.replace(toReplace, '');
                });
            }
        }
        return field;
    },
};
